exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".OurStory{padding-top:60px;padding-bottom:60px}.OurStory a:active,.OurStory a:hover,.OurStory a:link,.OurStory a:visited{color:#2d5da5}.OurStory__title{font-weight:700;font-size:2.8rem;font-family:Oswald,serif;letter-spacing:.1rem;text-align:center;margin-bottom:30px}@media screen and (max-width:767px){.OurStory__title{margin-bottom:20px}}.OurStory__content p:first-of-type{margin-top:0}.OurStory__photo{margin:7px 0 0 15px;padding-left:10px;float:right}@media screen and (max-width:767px){.OurStory__photo{display:block;float:none;text-align:center;margin:0 0 15px;padding-left:0}}.OurStory__floatBottomContainer{position:relative}.OurStory__spacer{float:left;width:0}.OurStory__floatBottomBlock{float:left;clear:left;margin:5px 15px 5px 0;height:69px;width:204px}@media screen and (max-width:767px){.OurStory{padding-top:40px;padding-bottom:40px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../src/components/ourStory/index.scss
// module id = 882
// module chunks = 0